// Copyright ©️ 2026 eVolve MEP, LLC

import type { RenderableSpool } from 'components/Autodesk/extensions/SpoolsExtension/types';
import { getBasicStoreListeners } from 'helpers/getBasicStoreListeners';

export type SpoolsBySpoolName = Record<string, RenderableSpool>;

export const createSpoolsStore = () => {
  let spools: SpoolsBySpoolName | null = null;

  const { subscribe, notifyListeners } = getBasicStoreListeners();

  return {
    getSnapshot: () => spools,
    subscribe,
    setSpools: (newSpools: SpoolsBySpoolName) => {
      spools = newSpools;
      notifyListeners();
    },
    clear: () => {
      spools = null;
      notifyListeners();
    },
  };
};

export type SpoolsStore = ReturnType<typeof createSpoolsStore>;
